import React, { useState, useEffect } from "react";
import { MaxipDialog } from "./MaxipDialog";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getLoggedIps, getFraudUsersByIp } from "./fraudSlice";
import { FRAUDSCRUB_CONSTANTS } from "../../sharedfiles/Constants";
import { generateKey } from "../../sharedfiles/helper";
import Skelton from "../Common/skeleton/Skeleton";
import NoDataFound from "../Common/table/NoDataFound";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";

const FraudScrub = (props) => {
  const [openMaxipDialog, setOpenMaxipDialog] = useState(false);
  const [ip, setIp] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  
  const handlePopUp = (ip) => {
    if (props?.loggedIps?.length > 0) {
      setIp(ip);
      dispatch(getFraudUsersByIp(ip.ip));
      setOpenMaxipDialog(true);
    }
  };
  useEffect(() => {
    let mounting = true;

    mounting && dispatch(getLoggedIps(props.userId));

    return () => mounting = false;
  }, []);

  useEffect(() => {
    const id = location.pathname.split("/")[2];
    if (props.userId !== id) {
      dispatch(getLoggedIps(id));
    }
  }, [location]);

  const commonStyles = {
    fontSize: "18px",
    fontWeight: "500",
    padding: "5px 10px",
  };
  const fraudStyle = {
    backgroundColor: "#FFAC48",
    ...commonStyles,
    hover: {
      backgroundColor: "#0091ff",
    },
  };
  const nonFraudStyle = {
    // #192239
    backgroundColor: "transparent",
    PointerEvents: "none",
    ...commonStyles,
  };
  function handleCloseMaxipDialog() {
    setOpenMaxipDialog(false);
  }

  const fraudHeaders = [FRAUDSCRUB_CONSTANTS.th_ip, FRAUDSCRUB_CONSTANTS.count];
  const fraudRowAccessors = [
    (item) => item.ip,
    (item) => (
      <span className='inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-400'>
        {item.count}
      </span>
    ),
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("fraudScrubFraudScrub", fraudHeaders);

  return (
    <>
      <MaxipDialog
        openMaxipDialog={openMaxipDialog}
        setOpenMaxipDialog={setOpenMaxipDialog}
        fraudUsers={props.fraudUsers}
        ip={ip}
        handleRevertBack={handleCloseMaxipDialog}
      />
      
      <div className='space-y-6'>
        <div>
          <h2 className='text-lg font-semibold text-foreground'>Fraud Detection</h2>
          <p className='text-sm text-muted-foreground mt-1'>Monitor and manage fraudulent IP addresses and user accounts</p>
        </div>

        {!props.isHightlight ? (
          <div className='flex items-center gap-2 p-4 rounded-lg border border-yellow-200 bg-yellow-50 dark:border-yellow-800 dark:bg-yellow-950/20'>
            <div className='text-yellow-700 dark:text-yellow-400'>
              <p className='text-sm font-medium'>ℹ Information</p>
              <p className='text-xs mt-1'>{props.errorMsg}</p>
            </div>
          </div>
        ) : (
          <div className='space-y-4'>
            <div className='flex justify-between items-center'>
              <h3 className='text-base font-semibold text-foreground'>{FRAUDSCRUB_CONSTANTS.maxUserIp}</h3>
              <span className='text-sm text-muted-foreground'>
                {FRAUDSCRUB_CONSTANTS.count}: {props.loggedIps?.length || 0}
              </span>
            </div>
            <div>
              {props.loggedIps &&
                props.loggedIps !== null &&
                props.loggedIps !== undefined &&
                Array.isArray(props.loggedIps) &&
                props.loggedIps.length > 0 ? (
                <div className="relative rounded-lg border bg-muted/30 overflow-hidden">
                  <TableToolbar
                    columns={allColumns}
                    onToggle={toggleVisibility}
                    onReorder={reorder}
                    onReset={resetToDefault}
                  />
                  <Table scrollKey="fraudScrubFraudScrub">
                    <TableHeader>
                      <TableRow>
                        {visibleIndices.map((origIdx) => (
                          <TableHead key={origIdx} className="whitespace-nowrap">{fraudHeaders[origIdx]}</TableHead>
                        ))}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {props.loggedIps.map((item, ind) => {
                          return (
                            <TableRow
                              className='cursor-pointer'
                              onClick={() => handlePopUp(item)}
                              key={generateKey(ind)}
                            >
                              {visibleIndices.map((origIdx) => (
                                <TableCell key={origIdx} className={origIdx === 0 ? 'text-sm font-mono' : 'text-sm'}>
                                  {fraudRowAccessors[origIdx](item)}
                                </TableCell>
                              ))}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </div>
              ) : (
                <Skelton hLen={2} vLen={3} />
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loggedIps: state.fraudscrub.loggedIps,
    fraudUsers: state.fraudscrub.fraudUsers,
    errorMsg: state.fraudscrub.errorMsg,
    userId: state.playersearch.userId,
    isHightlight: state.fraudscrub.isHightlight,
  };
};

export default connect(mapStateToProps)(FraudScrub);
